import { render, staticRenderFns } from "./ClientsOverview.vue?vue&type=template&id=24687752"
import script from "./ClientsOverview.vue?vue&type=script&lang=js"
export * from "./ClientsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports